import {Trans} from '@lingui/macro';
import _ from 'lodash';
import React, {FC, useMemo, useState} from 'react';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {useLinkNavigation} from '../../components/common/navigation/useLinkNavigation';
import {VacationResponderModel} from '../../models/api/vacationResponderModel';
import {buildSettingsPath} from '../../models/url/settingsUrlHelpers';
import {SettingsResourcePagesEnum, SettingsVacationRespondersUrl} from '../../models/url/settingsUrlModel';
import {ResourceMap} from '../../store/appTypes';
import {SettingsContentHeader} from '../common/settingsContentHeader';
import {StyledSettingsContent, StyledSettingsMain, StyledSettingsWrapper} from '../common/settingsWrapper';
import {SettingsHeader} from '../settingsHeader';
import {SettingsVacationRespondersTable} from './settingsVacationRespondersTable';

/*
 * Props.
 */

interface SettingsVacationRespondersListProps {
  vacationResponders: ResourceMap<VacationResponderModel>;
  vacationRespondersUrl: SettingsVacationRespondersUrl;
}

/*
 * Component.
 */

export const SettingsVacationRespondersList: FC<SettingsVacationRespondersListProps> = (props) => {
  const {vacationRespondersUrl, vacationResponders} = props;
  const [searchQuery, setSearchQuery] = useState('');
  const {navigateToLink} = useLinkNavigation();

  const onSearchQueryChange = (newQuery: string) => {
    setSearchQuery(newQuery);
  };
  const vacationResponderIds = useMemo(
    () =>
      _(vacationResponders)
        .values()
        .compact()
        .filter((s) => s?.name.toLowerCase().includes(searchQuery.toLowerCase()))
        .map((s) => s?.id)
        .compact()
        .value(),
    [vacationResponders, searchQuery],
  );

  const renderHeaderButton = (buttonProps: React.ComponentProps<typeof Button>) => (
    <Button
      {...buttonProps}
      variant={ButtonVariantsEnum.PRIMARY}
      onClick={() =>
        navigateToLink(
          buildSettingsPath({...vacationRespondersUrl, resourcePage: SettingsResourcePagesEnum.NEW}),
        )
      }
    >
      <Trans id="settings-vacationresponders-addavacationresponder">Add a vacation responder</Trans>
    </Button>
  );
  return (
    <StyledSettingsWrapper>
      <SettingsHeader>
        <Trans id="settings-vacationresponders-header">Vacation responders</Trans>
      </SettingsHeader>
      <StyledSettingsMain>
        <StyledSettingsContent>
          <SettingsContentHeader
            searchInputValue={searchQuery}
            onSearchInput={onSearchQueryChange}
            onExitClick={() => {
              setSearchQuery('');
            }}
            renderButtons={renderHeaderButton}
          />
          <SettingsVacationRespondersTable
            vacationRespondersIds={vacationResponderIds}
            vacationResponders={vacationResponders}
            vacationRespondersUrl={vacationRespondersUrl}
          />
        </StyledSettingsContent>
      </StyledSettingsMain>
    </StyledSettingsWrapper>
  );
};
